module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ba812d61e4b104a25ef999ac7d91bf3d.png";